"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Token = void 0;
/**
 * A bearer token for authentication on a web resource.
 */
class Token {
    /**
     * Initializes a new instance of the @see Token class.
     * @param accessToken The access token for a resource.
     * @param expires Expiration timestamp for this token.
     */
    constructor(accessToken, expires) {
        this.accessToken = accessToken;
        this.expires = expires;
    }
}
exports.Token = Token;
//# sourceMappingURL=token.js.map